import axios from 'axios'
import Router from '../router/index'
import Cookies from 'js-cookie'
import qs from 'qs'
import { Message } from 'view-design'
import { TOKEN_KEY } from '@/libs/util'
// import store from '@/store'

// import { Spin } from 'view-design'

class HttpRequest {
  constructor() {
    // this.publicPath = publicPath
    this.queue = {}
  }
  // getInsideConfig() {
  //   const config = {
  //     baseURL: this.publicPath,
  //     headers: {
  //       //
  //     }
  //   }
  //   return config
  // }
  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      config => {
        // console.log(config,'123')
        // console.log(config)
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        if (Cookies.get(TOKEN_KEY) && !config.url.includes('/token')) {
          config.headers['Authorization'] = 'Bearer ' + Cookies.get(TOKEN_KEY)
          config.params = config.params || {}
        }

        if (config.url.includes('/token')) {
          config.data = qs.stringify(config.data)
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
          // console.log(config)
        }
        // if(config.url.includes('/etc/login')) delete config.headers.Authorization
        this.queue[url] = true
        return config
      },
      error => {
        return Promise.reject(error)
      }
    )

    // 响应拦截
    instance.interceptors.response.use(
      res => {
        // console.log(this);
        // this.destroy(url)
        const { data } = res
        if (!data.code && data.code == '200') {
          data.code = '0'
        }

        if (
          !data.status &&
          data.code != 0 &&
          data.message.indexOf('10030') == -1
        ) {
          if (data.message == '不允许的设备登录') {
            Message.destroy()
            Message.error({
              content:
                '不允许登录的设备，有疑问请联系平台客服130-5208-5563',
              duration: 15
            })
            // Message.destroy()
          } else {
            Message.error(data.message)
          }
          // if (data.code == 400) {
          // console.log(11)
          // Message.destroy()
        }
        if (data.code == 503) {
          Router.push({
            path: '/503'
          })
        }

        return data
      },
      error => {
        this.destroy(url)
        // console.log(url)
        // console.log(error.message)
        // token失效
        if (error.message.includes('401')) {
          Message.destroy()
          Message.error('登录失效，请重新登录')
          Cookies.set(TOKEN_KEY, '', { expires: 1 })

          setTimeout(() => {
            window.location.href = '/login'
          }, 500)
        }
        if (error.message.includes('503')) {
          Router.push({
            path: '/503'
          })
        }
        if (error.message.includes('404')) {
          Router.push({
            path: '*'
          })
        }
        // 判断请求异常信息中是否含有超时timeout字符串
        if (error.message.includes('timeout')) {
          Message.error('网络超时')
        }
        if (error.message.includes('Network Error')) {
          Message.error('服务端未启动，或网络连接错误')
        }
        return Promise.reject(error)
      }
    )
  }

  request(options) {
    const instance = axios.create()
    // options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}

export default HttpRequest
